import { AttachmentFileList, AttachmentFileType, CloudFile } from 'owa-attachment-file-types';
import { ILinkPlugin } from 'owa-editor-link-plugin';
import { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { trace } from 'owa-trace';

export async function insertLinkHandler(
    files: AttachmentFileList,
    lazyLinkPlugin: LazyPlugin<ILinkPlugin>
) {
    // We only support insert from cloudy providers for now
    const filteredFiles: CloudFile[] = [];
    for (let i = 0; i < files.length; i++) {
        if (files[i].fileType === AttachmentFileType.Cloud) {
            const cloudFile: CloudFile = files[i] as CloudFile;
            filteredFiles.push(cloudFile);
        } else {
            trace.error(`insert link handler recieved invalid file type ${files[i].fileType}`);
        }
    }

    if (!filteredFiles || filteredFiles.length === 0 || !lazyLinkPlugin) {
        trace.error('No files or no plugin for insert link from filepicker');
        return;
    }

    const linkPlugin = await lazyLinkPlugin.getPlugin();

    if (linkPlugin) {
        linkPlugin.insertLinksFromFilePicker(filteredFiles);
    }
}
